'use strict';

var sharedState = require('./sharedState');
const $cache = sharedState.$cache;

const enableSearchButton = () => {
    let travelType = getCurrentTravelType();

    $cache.tripDeparture = $('#tripDeparture');
    $cache.tripDestination = $('#tripDestination');
    $cache.tripDateStart = $('#tripDateStart');
    $cache.tripDateEnd = $('#tripDateEnd');
    $cache.tripPassengers = $('#tripPassengers');

    if (
        !$cache.tripDeparture.val() ||
        !$cache.tripDateStart.val() ||
        !$cache.tripPassengers.val() ||
        !$cache.tripDestination.val() ||
        (travelType === 'round' && !$cache.tripDateEnd.val())
    ) {
        $cache.searchFlightsButton.prop('disabled', true);
        return;
    }

    $cache.searchFlightsButton.prop('disabled', false);
};

const getCurrentTravelType = () => {
    return $('input[type=radio][name=travelType]:checked').val();
};

const syncInputsState = () => {
    const readonly = window.app.isMobile();

    sharedState.debug('syncInputsState', 'readonly', readonly);

    $cache.tripDeparture.prop('readonly', readonly);
    $cache.tripDestination.prop('readonly', readonly);
    $cache.tripDateStart.prop('readonly', true);
    $cache.tripDateEnd.prop('readonly', true);
};

module.exports = {
    enableSearchButton: enableSearchButton,
    getCurrentTravelType: getCurrentTravelType,
    syncInputsState: syncInputsState
};